import { useSelector } from '~/_shared/utils/hooks/useSelector';
import type { AppState } from '~/store/app.store';

const mapSettingsSearchFilterBySelector = (state: AppState) => state.map.mapSettings.data.search.filterBy;
export const useMapSettingsSearchFilterBySelector = () => useSelector(mapSettingsSearchFilterBySelector);

const mapSettingsSearchShouldMatchExactWordsSelector = (state: AppState) => state.map.mapSettings.data.search.shouldMatchExactWords;
export const useMapSettingsSearchShouldMatchExactWordsSelector = () => useSelector(mapSettingsSearchShouldMatchExactWordsSelector);
